module.exports = __webpack_public_path__ + "static/media/restaurant.e25b675f.jpg";